// extracted by mini-css-extract-plugin
module.exports = {"nudge-texts":"_2Uijl","left_arrows":"_1TrP-","right_arrows":"SNKWA","age-text":"_1ZuHe"};